import ProcessingNodeBase from '~/models/journey/ProcessingNodeBase'
import CarrierFootprints from '~/composables/CarrierFootprints'

export class RunCarrierFootprintNode extends ProcessingNodeBase {
  run(): Promise<void> {
    CarrierFootprints.refresh()
    return Promise.resolve(undefined)
  }
}
